export const rootPath = "/";
export const startPath = "/start";
export const startStudentPath = "/start/student";
export const finishPath = "/finish";
export const allChartsPath = "/all_charts";
export const questionIndexPath = "/question_index";
